/* unplugin-vue-components disabled */import { render } from "./DocDesigner.vue?vue&type=template&id=6003a112&scoped=true"
import script from "./DocDesigner.vue?vue&type=script&lang=js"
export * from "./DocDesigner.vue?vue&type=script&lang=js"

import "./DocDesigner.vue?vue&type=style&index=0&id=6003a112&lang=less&scoped=true"
import "./DocDesigner.vue?vue&type=style&index=1&id=6003a112&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6003a112"]])

export default __exports__